import React from 'react';
import BaseComponentInternas from '../../Components/BaseComponentInternas';
import ChangeEmailComponent from '../../Components/ChangeEmail';
import HeaderStroke from '../../Components/HeaderStroke';

const ChangeEmail = () => {
  return (
    <BaseComponentInternas>
      <HeaderStroke name='Alterar e-mail' msgDadosCadastrais={true} />
      <ChangeEmailComponent />
    </BaseComponentInternas>
  );
};

export default ChangeEmail;
